import { render, staticRenderFns } from "./NlpWhySatoshiIcon3.vue?vue&type=template&id=900f2688"
import script from "./NlpWhySatoshiIcon3.vue?vue&type=script&lang=js"
export * from "./NlpWhySatoshiIcon3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports